import React from "react"
import PropTypes from "prop-types"
import withStyles from "@material-ui/core/styles/withStyles"

import { Link } from "react-router-dom"

import Card from "@material-ui/core/Card"
import CardContent from "@material-ui/core/CardContent"
import CardMedia from "@material-ui/core/CardMedia"
import ButtonBase from "@material-ui/core/ButtonBase"
import { Title, Text } from "ui-Text"

const styleSheet = theme => ({
  root: {
    height: "100%",

    [theme.breakpoints.up("sm")]: {
      transition: theme.transitions.create("box-shadow"),

      "&:hover": {
        boxShadow: theme.shadows[8],
      },
    },
  },

  cardButton: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    padding: 0,
    textTransform: "none",
  },

  linkButton: {
    ...theme.typography.button,
    color: theme.palette.secondary.main,
  },

  copyContent: {
    flex: 1,
    width: "100%",
  },

  linkContent: {
    width: "100%",
  },

  media: {
    height: 100,
    width: "100%",
    backgroundColor: theme.palette.background.default,
    backgroundSize: "cover",
  },
})

function ServiceCard({ children, classes, image, linkLabel, to, title, ...otherProps }) {
  return (
    <Card className={classes.root} {...otherProps}>
      <ButtonBase component={Link} to={to} className={classes.cardButton}>
        <CardMedia image={image} className={classes.media} />
        <CardContent className={classes.copyContent}>
          <Title paragraph>{title}</Title>
          <Text color="textSecondary">{children}</Text>
        </CardContent>
        <CardContent className={classes.linkContent}>
          <div className={classes.linkButton}>{linkLabel || "Learn More"}</div>
        </CardContent>
      </ButtonBase>
    </Card>
  )
}

ServiceCard.propTypes = {
  image: PropTypes.string,
  linkLabel: PropTypes.string,
  to: PropTypes.string,
  title: PropTypes.string,
}

export default withStyles(styleSheet)(ServiceCard)



// WEBPACK FOOTER //
// ./src/views/pages/Landing/ServiceCard.js